import React, { useState, useEffect } from "react";
import ChatInbox from "../components/ChatInbox";
import ChatScreen from "../components/ChatScreen";

const ChatPanel = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleBack = () => {
    setSelectedUser(null);
  };

  return (
    <div className="flex  w-full overflow-hidden ">
      {(!isMobile || !selectedUser) && (
        <div className="w-full md:w-1/3 border-r border-gray-300">
          <ChatInbox
            onSelectUser={setSelectedUser}
            selectedUser={selectedUser}
          />
        </div>
      )}

      {(isMobile && selectedUser) || !isMobile ? (
        <div className="w-full md:w-2/3 flex flex-col">
          {selectedUser ? (
            <ChatScreen
              userType="seller"
              chatWith={selectedUser}
              isMobile={isMobile}
              onBack={handleBack}
            />
          ) : (
            <div className="flex-1 flex items-center justify-center text-gray-500">
              Select a chat to start messaging
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default ChatPanel;
